import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import SiteInfoQuestions from 'components/sales/formSection/siteInfo/siteInfo';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';

const CivilCheckout = ({
  getCivilCheckList,
  civilData,
  getGateInfo,
  gateInfo,
  match,
  location,
  documentUploadUrl,
  postCivilCheckList,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setFormData] = useState(null);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);

  useEffect(() => {
    if (getCivilCheckList !== null) (async () => await getCivilCheckList(match?.params?.id,match?.params?.gateId))();
  }, [getCivilCheckList,match?.params?.id,match?.params?.gateId]);

  useEffect(() => {
    if (getGateInfo !== null && match.params.id && location.state.gateId)
      (async () => await getGateInfo(match.params.id, location.state.gateId))();
  }, [getGateInfo, match.params.id]);

  const handleSubmit = () => {
    console.log(formData);
    const count = JSON.parse(localStorage.getItem('count'));
    if (formData === null) {
      setIsFiled(true);
      setIsModal(false);
    } else {
      
      var  requiredCount = 0;
      formData.checklist_answers && formData.checklist_answers.map((checklistData) =>{
        if(checklistData.is_required == 1 || checklistData.is_required == true)
        requiredCount = requiredCount+1;
      });
      // console.log(requiredCount);
      // if (count <= formData.checklist_answers.length) {
        if (count == requiredCount) {
        
        setIsFiled(true);
        (async () => {
          setIsLoading(true);
          const res = await postCivilCheckList(formData);
          setIsLoading(false);
          if (res === true) {
            setIsModal(true);
          }
        })();
      } else {
        
        setIsFiled(true);
        const active = document.querySelector('.activeAnkInput');
        console.log(active);
        if(active){
          active.focus();
        }
        var errMsg = 'Please fill all required fields!';
        setIsErrorMsg(errMsg);
        // setIsErrorModal(true);
        setIsModal(false);
      }
    }
  };
  const handleFormVal = (val) => {
    setFormData(val);
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/gate/civil-checklist/${match.params.id}/stage/2`);
  };
  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  const handleModalHide1 = () => setIsErrorModal(false);
  return (
    <Layout
      title={localization.civilChecklist}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/gate/civil-checklist/${match.params.id}/stage/${match.params.stageId}`}
      isLoading={isLoading}
    >
      <SiteInfoQuestions
        className={isFiled ? 'requiredFileds' : ''}
        gateInfo={gateInfo}
        data={civilData}
        documentUploadUrl={documentUploadUrl}
        handleValue={handleFormVal}
        match={match}
        location={location}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/gate/civil-checklist/${match.params.id}/stage/2`}
            className="btn btn-primary mb-4"
          >
            {localization.viewCivilChecklist}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};
export default CivilCheckout;
